import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: ['chartdata', 'options'],
    mounted() {
        this.renderChart(this.chartdata, {

            maintainAspectRatio: true

        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/charts/linechart.js